<template lang="pug">

  transition(name="fade")
    #webaudio-interface

</template>

<script>

import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'
import WebAudioService from 'src/services/WebAudioService'

export default {

  name: 'webaudio-interface',
  
  components: {},
  
  data() {
    return { 
    }
  },
  
  computed: {
    ...mapState('app', ['consented']),
    ...mapState('question', ['STATES', 'state'])
  },
  
  mounted() { 
    WebAudioService.on(WebAudioService.Events.Consented, this.onConsented)
  },
  
  beforeDestroy() {},
  
  methods: { 

    ...mapMutations('app', ['setConstented']),

    updateQuestionState(val){
       switch(val) {
        case this.STATES.IDLE:
          WebAudioService.startStream(); 
          console.log('captureMedia')
          break; 
        case this.STATES.TAP_HOLD_RECORD:
          WebAudioService.record();
          console.log('record')
          break;  
        case this.STATES.PROCESSING:
          WebAudioService.stopRecording(); 
         // WebAudioService.stopStream(); 
          console.log('stop Recording')
          break; 
      }
    },

    onConsented(value){ 
      this.setConstented(value);
    }
  },
  
  watch: {
    'state'(val){
      this.updateQuestionState(val);
    }
  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#webaudio-interface 
</style>







